import React from 'react';
import CONFIG from 'Config/settings';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IkeaButton from '@ingka/button';
import './Button.scss';

export const Button = props => {
  const {
    margin,
    marginRight,
    marginLeft,
    marginTop,
    marginBottom,
    fullWidth,
    autoWidth,
    className,
    ...rest
  } = props;
  const prefix = CONFIG.APP.STYLES_PREFIX;
  return (
    <IkeaButton
      {...rest}
      prefix={prefix}
      style={props.style}
      className={classNames({
        [`${prefix}btn-margin-${margin}`]: margin !== undefined,
        [`${prefix}btn-margin-right-${marginRight}`]: marginRight !== undefined,
        [`${prefix}btn-margin-left-${marginLeft}`]: marginLeft !== undefined,
        [`${prefix}btn-margin-top-${marginTop}`]: marginTop !== undefined,
        [`${prefix}btn-margin-bottom-${marginBottom}`]:
          marginBottom !== undefined,
        [`${prefix}btn-full-width`]: fullWidth,
        [`${prefix}btn-auto-width`]: autoWidth,
        [className]: className
      })}
    />
  );
};

Button.propTypes = {
  type: PropTypes.oneOf([
    'transactional',
    'primary',
    'secondary',
    'tertiary',
    'danger'
  ]),
  htmlType: PropTypes.string,
  href: PropTypes.string,
  text: PropTypes.string,
  loading: PropTypes.bool,
  fullWidth: PropTypes.bool,
  autoWidth: PropTypes.bool,
  inverseTheme: PropTypes.bool,
  mobileFullWidth: PropTypes.bool,
  margin: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl']),
  marginTop: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl']),
  marginBottom: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl']),
  marginRight: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl']),
  marginLeft: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl']),
  ssrIcon: PropTypes.func,
  iconPosition: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  small: PropTypes.bool
};
